import { useEffect, useMemo, useRef, useState } from "react";
import styles from "../detalheEsocial.styles.module.css";
import {
  acaoLimparBaseLegal,
  acaoSelecionarSemBaseLegal,
  acaoSelecionarTodasBaseLegal,
  alternarBaseLegalSelecao,
  isBaseLegalMarcada,
  textoTriggerBaseLegal,
} from "../utils/baseLegalMultiSelect.util";

export default function FiltroBaseLegalMultiSelect({
  opcoes = [],
  selecionadas = [],
  onChange,
}) {
  const [aberto, setAberto] = useState(false);
  const [busca, setBusca] = useState("");
  const wrapRef = useRef(null);

  const opcoesFiltradas = useMemo(() => {
    const q = busca.trim().toLowerCase();
    if (!q) return opcoes;
    return opcoes.filter((b) => String(b.label).toLowerCase().includes(q));
  }, [opcoes, busca]);

  const textoTrigger = useMemo(
    () => textoTriggerBaseLegal(selecionadas, opcoes),
    [selecionadas, opcoes]
  );

  useEffect(() => {
    if (!aberto) return undefined;
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setAberto(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [aberto]);

  return (
    <div className={styles.filtroMsDropdown} ref={wrapRef}>
      <button
        type="button"
        className={styles.filtroMsTrigger}
        aria-haspopup="listbox"
        aria-expanded={aberto}
        onClick={() => setAberto((v) => !v)}
      >
        <span className={styles.filtroMsTriggerText}>{textoTrigger}</span>
        <span className={`${styles.filtroMsChevron} ${aberto ? styles.filtroMsChevronOpen : ""}`}>
          ▼
        </span>
      </button>
      {aberto && (
        <div className={styles.filtroMsPanel} role="listbox" aria-label="Base legal">
          {opcoes.length > 8 && (
            <input
              type="search"
              className={styles.filtroMsSearch}
              placeholder="Buscar base legal…"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              aria-label="Buscar na lista de bases legais"
            />
          )}
          <div className={styles.filtroMsActions}>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              title="Selecionar todas as linhas com base legal"
              onClick={() => onChange(acaoSelecionarTodasBaseLegal(opcoes))}
            >
              Selecionar todas
            </button>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              title="Selecionar apenas as linhas sem base legal"
              onClick={() => onChange(acaoSelecionarSemBaseLegal())}
            >
              Sem base legal
            </button>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              onClick={() => {
                onChange(acaoLimparBaseLegal());
                setBusca("");
              }}
            >
              Limpar
            </button>
          </div>
          <div className={styles.filtroMsList}>
            {opcoesFiltradas.length === 0 ? (
              <p className={styles.filtroMsEmpty}>Nenhuma base legal encontrada.</p>
            ) : (
              opcoesFiltradas.map((b) => (
                <label key={b.codigo} className={styles.filtroMsOption} title={b.label}>
                  <input
                    type="checkbox"
                    checked={isBaseLegalMarcada(b.codigo, selecionadas)}
                    onChange={() => onChange(alternarBaseLegalSelecao(b.codigo, selecionadas))}
                  />
                  <span className={styles.filtroMsOptionLabel}>{b.label}</span>
                </label>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
